import React from 'react';

import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  autoFocus?: boolean;
  size?: 'small' | 'middle';
  /** Names the field when the placeholder alone doesn't, e.g. two searches side by side. */
  ariaLabel?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder,
  autoFocus = true,
  size = 'middle',
  ariaLabel,
}) => (
  <Input
    autoFocus={autoFocus}
    size={size}
    aria-label={ariaLabel}
    allowClear
    prefix={<SearchOutlined className="text-gray-muted" />}
    placeholder={placeholder}
    value={value}
    onChange={(event) => onChange(event.target.value)}
  />
);

export default SearchInput;
